export default __webpack_public_path__ + "static/media/KanandaFerreira_03.e48a4ca1.jpg";